<template>
  <div class="main-container">
    <div class="container">
      <div class="left">
        <el-carousel indicator-position="outside" height="100%">
          <el-carousel-item v-for="item in 1" :key="item">
            <img src="@assets/login.png" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-form ref="form" :model="form" :rules="rules" class="login-form" @submit.prevent="login">
        <p class="title">精诊三维</p>
        <p class="subTitle">欢迎登录影像重建系统</p>
        <el-form-item prop="username">
          <el-input
            class="login_input"
            placeholder="手机号"
            size="large"
            v-model="form.username"
          >
            <!--            <template slot="prepend">+86</template>-->
            <i slot="prefix" class="el-icon-mobile-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            class="login_input"
            v-model="form.password"
            :type="form.psd"
            size="large"
            placeholder="输入密码"
          >
            <i slot="prefix" class="el-icon-message"></i>
            <img slot="suffix" class="hideSwich" ref="view" @mouseover="imgop(1)" @mouseout="imgop(2)" @click="imgswich(1)" src="@assets/hide1.png"/>
            <img slot="suffix" class="hideSwich" ref="hide" @mouseover="imgop(1)" @mouseout="imgop(2)" style="display:none" @click="imgswich(2)" src="@assets/view1.png"/>
          </el-input>
        </el-form-item>
        <el-select v-model="verifyphone" placeholder="请选择" v-if="needVerifycode" style="width: 220px;" class="phone-selector">
          <el-option
            v-for="item in phonelist"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-button v-if="needVerifycode" size="large" type="primary" @click="SendVerifySMS" class="sendsms_btn">发送验证码</el-button>
        <el-form-item prop="verifycode" v-if="needVerifycode" style="margin-top: 12px;">
          <el-input
            class="login_input"
            v-model="form.verifycode"
            size="large"
            placeholder="验证码">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="form.rememberMe">记住我</el-checkbox>
          <a class="login-form-forgot" @click="handleFindPass">账号激活</a>
          <el-button
            class="login_btn"
            :loading="loading"
            size="large"
            type="primary"
            @click="submit"
            block>
            登录
          </el-button>
          <div class="error" v-if="isError">
            <i class="el-icon-error"></i>
            <span>用户名或密码错误</span>
          </div>
          <div class="error" v-if="isFreeze">
            <i class="el-icon-error"></i>
            <span>账号异常，请联系您的对接人员</span>
          </div>
          <!-- <p class="newUser" @click="handleRegister">新用户登陆</p> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {mapActions} from 'vuex';
import {login as api} from '@/api';

export default {
  name: 'Login',
  data() {
    return {
      isError: false,
      isFreeze: false,
      form: {
        psd: 'password',
        username: '',
        password: '',
        rememberMe: true
      },

      // passwordFocus: false,
      loading: false,
      phonelist: [],
      verifyphone: null,
      verifycode: '',
      needVerifycode: false
    };
  },
  computed: {
    rules: () => ({
      username: [{required: true, message: '请输入账号', trigger: 'change'}],
      password: [{required: true, message: '请输入密码', trigger: 'change'}]
    })
  },
  methods: {
    ...mapActions('common', ['getUserInfo']),
    handleFindPass() {
      this.$router.push({
        name: 'ActivePass'
      });
    },
    imgswich(res) {
      if (res === 1) {
        this.form.psd = '';
        this.$refs.view.style.display = 'none';
        this.$refs.hide.style.display = 'block';
      } else {
        this.form.psd = 'password';
        this.$refs.hide.style.display = 'none';
        this.$refs.view.style.display = 'block';
      }
    },
    imgop(res) {
      if (res === 1) {
        this.$refs.hide.style.opacity = '1';
        this.$refs.view.style.opacity = '1';
      } else {
        this.$refs.hide.style.opacity = '0.6';
        this.$refs.view.style.opacity = '0.6';
      }
    },
    handleRegister() {
      this.$router.push({
        name: 'Register'
      });
    },
    async submit() {
      this.loading = true;
      this.isError = false;
      this.isFreeze = false;
      this.form.verifyphone = this.verifyphone;
      const {code, msg, smsto} = (await api.login(this.form)) || {};
      if (code === 10000) {
        await this.getUserInfo();
        this.$router.push({name: '/'});
      } else if (code === 19004) {
        this.isFreeze = true;
        this.isError = false;
      } else if (code === 55010) {
        this.$message({type: 'info', message: msg});
        this.phonelist = smsto;
        this.verifycode = '';
        this.needVerifycode = true;
      } else if (code === 55011) {
        this.$message({type: 'info', message: msg});
        this.needVerifycode = true;
      } else {
        this.$message({type: 'info', message: msg});
        this.isError = true;
        this.isFreeze = false;
      }
      this.loading = false;
    },
    SendVerifySMS() {
      if (this.verifyphone) {
        this.verifycode = '';
        this.submit();
      }
    }
  }
};
</script>
<style lang="scss">
.login-form .el-form-item__error{
  top:85% ;
}
.login_input .el-input__inner {
  color: #868686;
  height:48px;
}
.el-form .el-form-item .login_input   .el-input__inner {
  font-size: 14px !important;
  background-color: #F4F8F7 !important;
  border: 0;
}
.login_input .el-input__prefix{
  color: #868686 !important;
  top:4px;
}
.login_input .el-input__inner::placeholder {
  color: #868686 !important;
}
/* 谷歌 */
.login_input .el-input__inner::-webkit-input-placeholder {
  color: #868686 !important;
}
/* 火狐 */
.login_input .el-input__inner:-moz-placeholder {
  color: #868686 !important;
}
/*ie*/
.login_input .el-input__inner:-ms-input-placeholder {
  color: #868686 !important;
}
.login_input .el-input__inner::placeholder {
  color: #868686 !important;
}
.login_input{
  .hideSwich{
    cursor: pointer;
    height: 16px;
    width: 16px;
    opacity: 0.6;
  }
  .el-input__suffix{
    right: 14px;
    top: 8px;
    .el-input__suffix-inner{
      display: inline-block;
    }
}
}
.login-form{
  .el-checkbox {
     color: black !important;
  }
  .el-checkbox__inner {
    background-color: white;
  }
  .el-button.is-disabled {
    color: black !important;
  }
}

</style>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none;
  user-select: none;
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
  box-sizing: border-box;
}

.left {
  float: left;
  display: inline-block;
  background: url('~@/assets/login.png') no-repeat;
  width: 442px;
  height: 494px;
}

.left .el-carousel {
  height: 100%;
  overflow: hidden;
}

main {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.login-form {
  float: right;
  padding: 26px 52px;
  width: 442px;
  height: 494px;
  background: #fff;
}

.login-form-forgot {
  float: right;
  color: #999;
  text-decoration: none;
}

.login-form-icon {
  color: rgba(0, 0, 0, .36);
}

.login-form .title {
  margin: 0;
  font-size: 32px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #333333;
  line-height: 45px;
}

.login-form .subTitle {
  margin-bottom: 26px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #333333;
  line-height: 22px;
}

.el-input__prefix {
  line-height: 58px;
}

.login_btn {
  width: 335px;
  height: 48px;
  background: linear-gradient(45deg, #534BD5 0%, #5951FF 100%);
  box-shadow: 0px 20px 32px 0px rgba(12, 20, 73, 0.22);
  border-radius: 4px;
  margin-top: 8px;
}
.sendsms_btn {
  width: 110px;
  height: 36px;
}
.phone-selector {

}

.ant-btn-primary[disabled] {
  /*background: #d9d9d9;*/
}

.newUser {
  cursor: pointer;
  margin-top: 18px;
  font-size: 12px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #5850F8;
  line-height: 17px;
  text-align: center;
}

@media screen and (max-width: 576px) {
  .left {
    display: none;
  }
  .login-form {
    padding: 24px 16px;
    width: 94%;
    margin: 0 auto;
  }
  .el-input {
    width: 100%;
  }

  .login_btn {
    width: 100%;
  }
}

.main-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /*opacity:0.5;*/
  background: url('~@/assets/login-background.jpg') no-repeat;
  background-size: 100%;

  .container {
    box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.1);

    .title {
      text-align: center;
      color: #6b9bee;
      font-size: 30px;
      margin-bottom: 30px;
    }

    .btn {
      width: 100%;
    }

    .tip {
      color: #6b9bee;
      margin-top: 8px;
    }

    .error {
      color: red;
      text-align: center;
      margin-top: 5px;

      .el-icon-error {
        margin-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Login/index.vue